import { createFileRoute } from '@tanstack/react-router';

import { CompanySettingsPage } from '../../modules/company-settings/company-settings-page.js';

export const Route = createFileRoute('/company-settings/')({
  component: CompanySettingsPage,
});
